export default {
  label: {
    title: 'Importar archivo',
    file: 'Archivo',
    insertFile: 'Seleccione el documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    send: 'Enviar',
    clear: 'Limpiar',
    requiredValue: 'Valor obligatorio',
    queued: 'En cola',
    proccessed: 'Procesado con éxito',
    status: 'Estado: ',
    totalPosts: 'Total de Publicaciones: ',
    dataStorageUrl: 'Enlace de la planilla procesada: ',
    errorMessage: 'Descripción del error: ',
  },

  infoLabel: 'Información del formulario',
  closeLabel: 'Cerrar información',
  exportLinkText: 'Enlace de la planilla procesada',

  upload: {
    error: 'Hay errores en los posts de la planilla, verifique los datos e intente nuevamente.',
    success: 'Documento cargado con éxito',
  },

  faq: {
    title: '¿Cuál es el formato de la planilla?',
    description: 'La planilla debe estar en formato .xlsx y en el formato correcto para la importación.',
  },
  faq2: {
    title: '¿Cuál es la formateación correcta de la planilla?',
    description: 'Basta seguir la planilla base enviada en la contratación del componente.',
  },
  faq3: {
    title: '¿Cómo saber si mis datos fueron importados?',
    description: 'Los datos importados aparecerán en el Warroom, en el mural de publicaciones dentro del canal "Datos Importados".',
  },
  faq4: {
    title: '¿Qué hacer si la planilla presenta errores?',
    description: 'El componente devolverá un enlace a la planilla con todas las filas que presentaron errores, informándolos. Es posible corregir los errores de la planilla devuelta y reenviarla para que sea importada correctamente.',
  },
};
